/* eslint-disable no-unused-vars */
import ApiService from "../api.service";
import appConfig from "../../../app-config";
import { TokenStorage } from "../../storage";

ApiService.init(appConfig.VUE_APP_ROOT_API);

const CustomerContactService = {
  async getByCustomerCode(code) {
    const requestScreenData = {
      url: "api/CustomerContact",
      top: "1",
      filter: `CustomerCode eq '${code}'`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByRecordId(recordId) {
    const requestScreenData = {
      url: "api/CustomerContact",
      expand: "Customer($select=Code,Name)",
      top: "1",
      filter: `RecordId eq ${recordId}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  async getByCustomerCodeLineNo(customerCode, lineNo) {
    const requestScreenData = {
      url: "api/CustomerContact",
      expand: "Customer($select=Code,Name)",
      top: "1",
      filter: `CustomerCode eq '${customerCode}' and LineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },

  dataSourceConfig(url, params) {
    params.key = ["LineNo"];
    params.keyType = {
      LineNo: "Int32",
    };

    // params.key = ["RecordId"];
    // params.keyType = {
    //   RecordId: "Guid",
    // };

    return ApiService.createDataSource(url, params);
  },

  dataSourceConfigList(url, params) {
    params.key = ["RecordIdAsString"];
    params.keyType = {
      RecordIdAsString: "String",
    };

    return ApiService.createDataSource(url, params);
  },
  async save(mode, customerContact) {
    var payload = customerContact;
    var url = "api/Save_CustomerContact";

    if (mode == "create") {
      return await ApiService.post(url, payload, "Guid");
    } else {
      return await ApiService.put(
        url,
        customerContact.RecordId,
        payload,
        "Guid"
      );
    }
  },
  async delete(customerContact) {
    var payload = customerContact;
    var url = "api/Save_CustomerContact";

    return await ApiService.delete(url, customerContact.RecordId, "Guid");
  },
};

const CustomerContactTransactionDistributionService = {
  async getByCustomerCodeLineNo(code, lineNo) {
    const requestScreenData = {
      url: "api/CustomerContactTransactionDistribution",
      filter: `CustomerCode eq '${code}' and LineNo eq ${lineNo}`,
    };

    return await ApiService.oDataGet(requestScreenData);
  },
};

export {
  CustomerContactService,
  CustomerContactTransactionDistributionService,
};
